define('views/shared/footer/footer',[
	'backbone',
	'text!views/shared/footer/footer.html',
	'views/_base/baseview',
	'views/shared/footer/footer_column',
], function (Backbone, Template, BaseView, FooterColumnComponent) {
	'use strict';

	return BaseView.extend({
		id: 'footer-inner-container',
		tagName: 'footer',
		className: 'cf',
		template: _.template(Template),
		isRender: true,
		needsAuth: false,
		events: {},

		initialize: function (options) {
			options = options || {};

			this.site_version = pf.getContent('version.id');

			this.wellness = pf.getFeature(enums.features.wellness);

			BaseView.prototype.initialize(this);
		},

		render: function () {
			this.$el.html(this.template());

			this.addFooterColumns();

			if (this.site_version != enums.siteVersion.bcbssc) {
				// this.addSocialIcons();
			}

			return this;
		},

		addFooterColumns: function () {
			var columns = pf.getContent('footer.content.columns');

			if (_.isArray(columns)) {
				var that = this;

				columns.forEach(function (column) {
					if (column.header.text === 'About' && !that.wellness) {
						column.links.unshift(
							pf.getContent('footer.content.digital_wallet.link')
						);
					}

					if (_.isObject(column)) {
						if (
							column.header.text === 'Quick Links' &&
							(isSunsetting() ||
								that.site_version == enums.siteVersion.payforward)
						) {
							return;
						}

						var footer_column = new FooterColumnComponent({ column: column });

						that.$('.js-footer-links-columns').append(footer_column.el);
					}
				});
			}
		},

		addSocialIcons: function () {
			var that = this,
				links = pf.getContent('footer.content.social_links');

			if (_.isArray(links)) {
				links.forEach(function (link) {
					var anchor = document.createElement('a');

					anchor.className = link.class;
					anchor.href = link.url;
					anchor.innerHTML = pf.getContent(link.icon);

					if (link.target) {
						anchor.target = link.target;
					}

					that.$('.js-footer-social-links').append(anchor);
				});
			}
		},

		close: function () {},
	});
});

